import { render } from "./buy-trial.vue?vue&type=template&id=f942bdc6"
import script from "./buy-trial.vue?vue&type=script&lang=js"
export * from "./buy-trial.vue?vue&type=script&lang=js"

import "./buy-trial.vue?vue&type=style&index=0&id=f942bdc6&lang=scss"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.16_vue@3.5.13_typescript@5.1.6__webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__